// Reviews Mobile - Highlight on Scroll
(function() {
  const highlightElements = document.querySelectorAll('.p-herbs-col-highlight');
  const viewportMid = window.innerHeight * 0.9;
  const highlightState = new Map();
  highlightElements.forEach(el => highlightState.set(el, false));
  
  window.addEventListener('scroll', () => {
    highlightElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      const elCenter = rect.top + rect.height / 2;
      const currentlyActive = highlightState.get(el);
      
      if (elCenter <= viewportMid && !currentlyActive) {
        el.classList.add('active');
        highlightState.set(el, true);
      } else if (elCenter > viewportMid && currentlyActive) {
        el.classList.remove('active');
        highlightState.set(el, false);
      }
    });
  });
})();
